// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Field from "../layout-and-structure/Field.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Button from "../actions/Button.res.js";
import * as Offset from "../layout-and-structure/Offset.res.js";
import * as TextInput from "../../primitives/TextInput.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as CopyButton from "../actions/CopyButton.res.js";
import * as LegacyIcon from "../images-and-icons/LegacyIcon.res.js";
import * as ReactAria from "react-aria";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as TextFieldStyle from "./TextFieldStyle.res.js";
import * as ReactDomElement from "../../primitives/ReactDomElement.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "opacity-kSiTet": "opacity-x1ks1olk",
    ":not(:hover)_backgroundColor-kmRCyk": "backgroundColor-x1lujfql",
    $$css: "wino-gc:src/resources/selection-and-input/InputTextField.res.js:22"
  }
};
function InputTextField$EraseAppender(props) {
  let onRequestInputClear = props.onRequestInputClear;
  let onRequestInputFocus = props.onRequestInputFocus;
  return JsxRuntime.jsx(Offset.make, {
    children: JsxRuntime.jsx(Button.make, {
      ariaProps: {
        "aria-label": "clear",
        preventFocusOnPress: true
      },
      variant: {
        NAME: "ghost",
        VAL: {}
      },
      size: "small",
      icon: "cross",
      iconSize: 15,
      excludeFromTabOrder: true,
      stylex: Primitive_option.some(styles.root),
      onPress: () => {
        onRequestInputFocus();
        onRequestInputClear();
      }
    }),
    right: -8.5,
    width: 32,
    height: 32
  });
}
let styles$1 = {
  root: {
    "opacity-kSiTet": "opacity-x1ks1olk",
    ":not(:hover)_backgroundColor-kmRCyk": "backgroundColor-x1lujfql",
    $$css: "wino-gc:src/resources/selection-and-input/InputTextField.res.js:60"
  }
};
function InputTextField$CopyAppender(props) {
  return JsxRuntime.jsx(Offset.make, {
    children: JsxRuntime.jsx(CopyButton.make, {
      value: props.value,
      variant: {
        NAME: "ghost",
        VAL: {}
      },
      size: "small",
      stylex: Primitive_option.some(styles$1.root)
    }),
    right: -8.5,
    width: 32,
    height: 32
  });
}
let styles$2 = {
  root: {
    "opacity-kSiTet": "opacity-x1ks1olk",
    ":not(:hover)_backgroundColor-kmRCyk": "backgroundColor-x1lujfql",
    $$css: "wino-gc:src/resources/selection-and-input/InputTextField.res.js:86"
  }
};
function InputTextField$RevealAppender(props) {
  let revealed = props.revealed;
  let label = revealed ? I18n.t("Hide") : I18n.t("Show");
  return JsxRuntime.jsx(Offset.make, {
    children: JsxRuntime.jsx(Button.make, {
      ariaProps: {
        "aria-label": label,
        preventFocusOnPress: true
      },
      variant: {
        NAME: "ghost",
        VAL: {}
      },
      size: "small",
      bold: revealed,
      active: revealed,
      icon: "see_ok",
      iconSize: 15,
      tooltipText: label,
      excludeFromTabOrder: true,
      stylex: Primitive_option.some(styles$2.root),
      onPress: props.onRequestToggle
    }),
    right: -8.5,
    width: 32,
    height: 32
  });
}
function InputTextField$ListAppender(props) {
  let opened = props.opened;
  let disabled = props.disabled;
  let match = Hover.use(undefined, undefined, undefined);
  let hovered = match[1];
  let match$1 = React.useState(() => false);
  let setPressed = match$1[1];
  let toggleButtonProps = ReactAria.mergeProps(props.toggleButtonProps, {
    elementType: "div",
    isDisabled: disabled,
    onPressStart: param => setPressed(param => true),
    onPressEnd: param => setPressed(param => false)
  });
  let style = {
    backgroundColor: disabled ? "#f8f8fb" : match$1[0] ? "#f3f3f7" : hovered || opened ? "#f8f8fb" : "transparent",
    borderLeftColor: TextFieldStyle.borderColor(props.inputFocused, props.inputHovered, props.inputErrored, disabled),
    borderLeftStyle: "solid",
    borderLeftWidth: "1px",
    alignItems: "center",
    display: "flex",
    flex: "0",
    flexBasis: "38px",
    height: "100%",
    justifyContent: "center",
    marginLeft: "4px",
    marginRight: "-9.6px"
  };
  let iconFillColor = disabled ? "#d7d7e0" : hovered || opened ? "#25243a" : "#797885";
  return JsxRuntime.jsx(Touchable.make, {
    children: JsxRuntime.jsx(LegacyIcon.make, {
      name: "arrow_down_light",
      fill: iconFillColor,
      size: 20
    }),
    ariaProps: toggleButtonProps,
    disabled: disabled,
    style: Primitive_option.some(style),
    ref: match[0]
  });
}
function style(focused, hovered, errored, disabled, bordered) {
  return {
    backgroundColor: TextFieldStyle.backgroundColor(disabled),
    border: bordered ? "1px solid" : "none",
    borderColor: TextFieldStyle.borderColor(focused, hovered, errored, disabled),
    display: "flex",
    height: "40px",
    overflow: "hidden",
    padding: `0 ` + "12px",
    borderRadius: TextFieldStyle.borderRadiusPx,
    columnGap: "8px",
    alignItems: "center",
    flexDirection: "row",
    boxSizing: "border-box"
  };
}
function textInputStyle(disabled) {
  return {
    color: TextFieldStyle.color(disabled),
    fontSize: TextFieldStyle.fontSizePx,
    height: "35px",
    width: "0",
    flex: "1",
    textOverflow: "ellipsis"
  };
}
let make = React.forwardRef((props, ref) => JsxRuntime.jsx(Field.make, {
  children: props.children,
  label: props.label,
  labelAriaProps: props.labelProps,
  tooltip: props.tooltip,
  errorMessage: props.errorMessage,
  action: props.fieldAction,
  required: props.required,
  ref: ref == null ? undefined : Primitive_option.some(ref)
}));
function InputTextField(props) {
  let onBlur = props.onBlur;
  let onFocus = props.onFocus;
  let onChange = props.onChange;
  let __value = props.value;
  let ariaProps = props.ariaProps;
  let errorMessage = props.errorMessage;
  let __copyable = props.copyable;
  let __secureTextEntry = props.secureTextEntry;
  let __focused = props.focused;
  let __bordered = props.bordered;
  let __disabled = props.disabled;
  let label = props.label;
  let __variation = props.variation;
  let variation = __variation !== undefined ? __variation : "normal";
  let disabled = __disabled !== undefined ? __disabled : false;
  let bordered = __bordered !== undefined ? __bordered : true;
  let focused = __focused !== undefined ? __focused : false;
  let secureTextEntry = __secureTextEntry !== undefined ? __secureTextEntry : false;
  let copyable = __copyable !== undefined ? __copyable : true;
  let value = __value !== undefined ? __value : "";
  let inputRef = Stdlib_Option.getOr(props.inputRef, React.useRef(null));
  let match = Hover.use(props.containerRef, undefined, undefined);
  let hovered = match[1];
  let match$1 = React.useState(() => false);
  let setInputFocused = match$1[1];
  let match$2 = React.useState(() => false);
  let setRevealed = match$2[1];
  let revealed = match$2[0];
  let match$3 = ReactAria.useLabel({
    label: label,
    "aria-label": label
  });
  let focusInput = () => {
    let input = inputRef.current;
    if (!(input == null)) {
      return ReactDomElement.focus(input);
    }
  };
  let handleFocus = () => {
    setInputFocused(param => true);
    Stdlib_Option.forEach(onFocus, onFocus => onFocus());
  };
  let handleBlur = () => {
    setInputFocused(param => false);
    Stdlib_Option.forEach(onBlur, onBlur => onBlur());
  };
  let errored = Stdlib_Option.isSome(errorMessage);
  let style$1 = style(focused, hovered, errored, disabled, bordered);
  let textInputStyle$1 = textInputStyle(disabled);
  let value$1 = Stdlib_Option.getOr(Stdlib_Option.flatMap(ariaProps, ariaProps => ariaProps.value), value);
  let ariaProps$1 = ReactAria.mergeProps(ariaProps, match$3.fieldProps);
  let clearHandler;
  let exit = 0;
  if (typeof variation === "object" && variation.NAME === "suggestion" && !disabled) {
    clearHandler = variation.VAL.onRequestClear;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    clearHandler = onChange !== undefined ? () => onChange("") : undefined;
  }
  let appenderElement = value$1 === "" ? null : secureTextEntry ? JsxRuntime.jsx(InputTextField$RevealAppender, {
    revealed: revealed,
    onRequestToggle: () => setRevealed(revealed => !revealed)
  }) : disabled || copyable && !(focused || match$1[0]) ? JsxRuntime.jsx(InputTextField$CopyAppender, {
    value: value$1
  }) : clearHandler !== undefined ? JsxRuntime.jsx(InputTextField$EraseAppender, {
    onRequestInputFocus: focusInput,
    onRequestInputClear: clearHandler
  }) : null;
  let tmp;
  if (typeof variation === "object" && variation.NAME === "suggestion") {
    let match$4 = variation.VAL;
    tmp = JsxRuntime.jsx(InputTextField$ListAppender, {
      inputFocused: focused,
      inputErrored: errored,
      inputHovered: hovered,
      disabled: match$4.toggleButtonDisabled || disabled,
      opened: match$4.opened,
      toggleButtonProps: match$4.toggleButtonProps
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx(make, {
    children: JsxRuntime.jsxs("div", {
      children: [JsxRuntime.jsx(TextInput.make, {
        inputRef: Primitive_option.some(inputRef),
        ariaProps: ariaProps$1,
        placeholder: props.placeholder,
        maxLength: props.maxLength,
        readOnly: disabled,
        autoTrim: props.autoTrim,
        secureTextEntry: secureTextEntry && !revealed,
        autoFocus: props.autoFocus,
        style: textInputStyle$1,
        value: value$1,
        onChange: onChange,
        onFocus: handleFocus,
        onBlur: handleBlur
      }), appenderElement, tmp],
      style: style$1
    }),
    label: label,
    required: props.required,
    fieldAction: props.fieldAction,
    tooltip: props.tooltip,
    errorMessage: errorMessage,
    labelProps: match$3.labelProps,
    ref: match[0]
  });
}
let make$1 = React.memo(InputTextField);
export { textInputStyle, make$1 as make };
/* styles Not a pure module */